import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

// Create root and render app
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Register service worker only in production and not in StackBlitz
if (process.env.NODE_ENV === 'production' && !window.location.hostname.includes('stackblitz')) {
  registerServiceWorker();
}

// Report web vitals
reportWebVitals(console.log);